// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"8cf5c644","574":"c39595b1","673":"c489f9a7","804":"46441632"}[chunkId] + ".chunk.css";
};